<app-loader></app-loader>
<!--<router-outlet></router-outlet>-->
<div ui-view style="height:100%"></div>

